import React from 'react';
import { LoginConnectorApollo, UserDataConnectorApollo } from '@front-activerse/common-components';
import AuthLoginByEmailAndPasswordForm from '../../Auth/Login/AuthLoginByEmailAndPasswordForm';

interface IActiveProductLoginContainer {
  pathActiveProduct: string;
}

const ActiveProductLoginContainer: React.FC<IActiveProductLoginContainer> = ({
  pathActiveProduct,
}) => {
  return (
    <LoginConnectorApollo>
      {({ ...login }: { login: any }) => (
        <UserDataConnectorApollo>
          {({ ...userDataOnDemand }: { userDataOnDemand: any }) => (
            <AuthLoginByEmailAndPasswordForm
              {...userDataOnDemand}
              login={login.login}
              userDataOnDemand={userDataOnDemand.userDataOnDemand}
              redirectToPathAfterSuccess={pathActiveProduct}
            />
          )}
        </UserDataConnectorApollo>
      )}
    </LoginConnectorApollo>
  );
};

export default ActiveProductLoginContainer;
